import React from 'react'

export default function AdminCenterRequestsManagement() {
  return (
    <div>AdminCenterRequestsManagement</div>
  )
}
